export enum DesignSubmittalDisposition {
  NoComments = 'Returned with no Comments',
  Comments = 'Returned with Comments',
  Comments_NoResubmit = 'Returned with Comments - No Resubmittal Required',
  Rejected = 'Rejected',
}
